import { Button, Card, Form, Input } from 'antd';
import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import style from './LoginPage.module.css';
import {
  $authStatus,
  getUserInfoEv,
  loginEv,
  loginFx,
} from '../../models/authModel/index.js';
import { cookies } from '../../api/axiosinstance.js';

function LoginPage() {
  const authStatus = useUnit($authStatus);
  const login = useUnit(loginEv);
  const navigate = useNavigate();
  const loading = useUnit(loginFx.pending);

  useEffect(() => {
    if (authStatus) {
      const token = cookies.get('access_token');
      if (token) {
        navigate('/');
      }
    }
  }, [authStatus]);

  return (
    <div className={style.login_container}>
      <Card>
        <Form layout="vertical" onFinish={login}>
          <Form.Item name="email" label="Email" required>
            <Input />
          </Form.Item>
          <Form.Item name="password" label="Password" required>
            <Input type="password" />
          </Form.Item>
          <div style={{ textAlign: 'center' }}>
            <Button type="primary" htmlType="submit" loading={loading}>
              Login
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
}

export default LoginPage;
